
<template>
  <div id="supportConfirm">
    <dd-header />
    <h2 class="hakotan_title">送信完了</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <section class="support_section">
            <div class="support_complete_area">
              <div class="support_complete">
                お問い合わせを送信しました。
              </div>
              <div class="btn_pos_center btn_color support_btn" @click="top()">トップページ</div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'

// Module
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'

export default {
  name: 'SupportComplete',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'supportComplete'
    }
  },
  methods: {
    top: function () {
      this.$router.push('/top')
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcSupportComplete.vue